export async function validateProject(project) {
  console.log(`placeholder for validating projects`, project.id)
  return true
}
